import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44feec4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "financial-wrapper" }
const _hoisted_2 = { class: "register-help" }
const _hoisted_3 = {
  class: "border-bottom",
  style: {"margin-top":"24px","padding-bottom":"24px"}
}
const _hoisted_4 = { class: "ris-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ris-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 预算编制时间：在确认⼤概开业时间时，即可联系财务管理中心咨询编制预算表。 完成预算表单填写后，需财务部进行审核，表单确认无误后则审批通过， "),
    /*#__PURE__*/_createElementVNode("span", { class: "orange" }, "《个人借款协议与合同会签表原件》需邮寄至集团")
  ])
], -1))
const _hoisted_7 = { class: "help-file-wrapper" }
const _hoisted_8 = { style: {"margin":"24px auto 17px"} }
const _hoisted_9 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_10 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_11 = { style: {"width":"500px"} }
const _hoisted_12 = { class: "content-wrapper" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, [
  /*#__PURE__*/_createTextVNode(" 元"),
  /*#__PURE__*/_createElementVNode("span", { class: "form-notation" }, "注：若借款金额超过5万元，需集团总经理审批")
], -1))
const _hoisted_14 = {
  key: 1,
  class: "borrow-tips"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-money" }, "借款金额：", -1))
const _hoisted_16 = { style: {"color":"#333"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-notation" }, "注：若借款金额超过5万元，需集团总经理审批", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "border-bottom",
  style: {"margin-top":"24px"}
}, null, -1))
const _hoisted_19 = {
  key: 2,
  class: "flow-box"
}

import {
  ref,
  watch,
  computed,
  withDefaults,
  createVNode,
  watchEffect,
} from "vue";
import { USERLIST } from "../../const/home";
import HeadTitle from "@/components/HeadTitle.vue";
import Approval from "@/components/Approval.vue";
import HelpFile from "@/components/HelpFile.vue";
import HelpText from "@/components/HelpText.vue";
import { Modal } from "ant-design-vue";
import { FileType, File, NodeItem } from "../../types/procss";
import Image from "../../components/Image.vue";
import type { FormInstance } from "ant-design-vue";
import { message } from "ant-design-vue";
import ButtonGroup from "@/components/ButtonGroup.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { approve } from "../../api/openapply";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { GetCurrentMyPageList } from "@/api/index";
import { nextTick } from "vue";
import {
  budgetDetail,
  submitBudgetApply,
  editBudgetApply,
  recallBudgetApply,
  borrowApplyDetail,
  borrowEditApply,
  borrowSubmitApply,
  borrowRecallApply,
} from "@/api/financial";


export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const currentStep = ref<number>(0);
const formRef = ref<FormInstance>(); // 财务预算表单
const formRefPersonBorrow = ref<FormInstance>(); // 个人借款附件表单
const formItemLoanamount = ref<FormInstance>(); // 个人借款金额表单
const preData = ref<NodeItem>();
const currentData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);
const WorkFlowId = ref<number>(0);
const route = useRoute();
const actionButtons = ref<(string | number)[]>(["100"]); //
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识
const firstIn = ref<boolean>(true);
const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);
const router = useRouter();
const { query } = route;
const id = ref(query.id || "");
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);



watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      BranchCompanyFlowId.value = id;
      currentData.value = val.find((item: NodeItem) => item.Code == type);
      if (currentData.value.ChildAnchorPointCode) {
        currentData.value = val.find(
          (item: NodeItem) =>
            item.Code == currentData.value.ChildAnchorPointCode
        );
      }
      currentStep.value = currentData.value?.Code == "201" ? 0 : 1;
    } else {
      //从流程节点页面进入
      let _parent_data = val.find((item: NodeItem) => item.Code == "2");
      currentData.value = val.find(
        (item: NodeItem) => item.Code == _parent_data?.ChildAnchorPointCode
      );
      if (currentData.value) {
        if (firstIn.value) {
          //第一次进入
          currentStep.value = currentData.value?.Code == "201" ? 0 : 1;
        }
      }
    }
    firstIn.value = false;
    handleTabChange(currentStep.value);
  },
  {
    deep: true,
  }
);
watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});
const fpNumInput = (e: any) => {
  const o = e.target;
  const inputRule = /[^\d]/g;
  nextTick(() => {
    personBorrowLoanamount.value.Loanamount = o.value.replace(inputRule, "");
  });
};



const edit = computed(
  () =>
    actionButtons.value?.includes("100") ||
    actionButtons.value?.includes("-2") ||
    actionButtons.value?.includes("90")
);

const fileList: { title: string; type: FileType; link: string }[] = [
  {
    title: "集团财务篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2024/202406/20240613/20240613_112609797574942_集团财务篇.pdf",
  },
];

const tableData = [
  {
    depart: "财务管理中心",
    name: "张馨予",
    duty: "开业预算审批、财务接⼝⼈分配",
    email: "Zhangxinyu@risfond.com",
    phone: "15010170908",
  },
  {
    depart: "风控合规中心",
    name: "郑晓雪",
    duty: "合同审批、法律咨询",
    email: "xiaoxue.zheng@risfond.com",
    phone: "13911699671",
  },
];
const list = ["提交财务预算申请", "提交个人借款申请"];
const recallVisible = ref<boolean>(false);
const recallResume = ref<string>("");

let formItemFinancial = ref<{ PageFiles: File[] }>({
  PageFiles: [],
});
let formItemPersonBorrow = ref<{ PageFiles: File[] }>({
  PageFiles: [],
});
let personBorrowLoanamount = ref({
  Loanamount: "",
});

//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    actionButtons.value = ["100"];
    if (currentStep.value == 0) {
      formItemFinancial.value.PageFiles[index as number] = {};
    } else if (currentStep.value == 1) {
      formItemPersonBorrow.value.PageFiles[index as number] = {};
    }
  } else {
    if (currentStep.value == 0) {
      formItemFinancial.value.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    } else if (currentStep.value == 1) {
      formItemPersonBorrow.value.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    }
  }
};
const handleClick = async (actionButtonsType: number | string) => {
  if (actionButtonsType == "100") {
    //提交申请
    if (currentStep.value == 0) {
      handleBudgetSubmitApply();
    } else if (currentStep.value == 1) {
      handleBorrowSubmitApply();
    }
  } else if (actionButtonsType == "101") {
    //撤回申请
    recallVisible.value = true;
  } else if (actionButtonsType == "102") {
    //重新提交申请
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (actionButtonsType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (actionButtonsType == "103") {
    applyOnOkVisible.value = true;
    //通过
    // Modal.confirm({
    //   content: "您确认要通过审核吗？",
    //   icon: createVNode(ExclamationCircleOutlined),
    //   onOk() {
    //     pass();
    //   },
    //   style: {
    //     top: "30%",
    //   },
    //   cancelText: "取消",
    //   onCancel() {
    //     Modal.destroyAll();
    //   },
    // });
  } else if (actionButtonsType == "-1") {
    reEdit.value = false;
    if (currentStep.value == 0) {
      getBudgetDetail();
    } else if (currentStep.value == 1) {
      getBorrowApplyDetail();
    }
  } else if (actionButtonsType == "-2") {
    if (currentStep.value == 0) {
      // 提交
      submitEditBudgetApply();
    } else {
      submitEditBorrowApply();
    }
  }
};
// //通过审核
// const pass = async () => {
//   const { Success } = await approve({
//     Description: "",
//     WorkflowId: WorkFlowId.value,
//     Status: 1, //1:通过 2: 驳回
//   });
//   if (Success) {
//     message.success("提交成功");
//     $emit("update-flow");
//     getList();
//   } else {
//     message.success("提交失败");
//   }
//   Modal.destroyAll();
// };

// 财务预算申请
const handleBudgetSubmitApply = () => {
  formRef.value?.validateFields().then(async () => {
    //提交申请
    const { Success, Message } = await submitBudgetApply({
      BranchCompanyFlowId: 0,
      PageFiles: formItemFinancial.value.PageFiles || [],
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      // getBudgetDetail();
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
// 个人借款提交
const handleBorrowSubmitApply = () => {
  formRefPersonBorrow.value?.validateFields().then(async (res) => {
    formItemLoanamount.value?.validateFields().then(async (res) => {
      const { Success, Message } = await borrowSubmitApply({
        BranchCompanyFlowId: 0,
        PageFiles: formItemPersonBorrow.value.PageFiles || [],
        PageData: {
          BorrowAmount: personBorrowLoanamount.value.Loanamount,
        },
      });
      if (Success) {
        message.success("已提交审核");
        $emit("update-flow");
        // getBorrowApplyDetail();
      } else {
        message.error(Message || "提交失败，请稍后重试");
      }
    });
  });
};
// 获取财务预算详情
const getBudgetDetail = async () => {
  const { Data } = await budgetDetail({ Id: BranchCompanyFlowId.value });
  actionButtons.value = Data?.ActionButtons || [];
  if (Data?.PageFiles.length > 0) {
    formItemFinancial.value.PageFiles = Data?.PageFiles;
  }
  WorkFlowId.value = Data?.WorkFlowId;
};
// 获取个人借款详情
const getBorrowApplyDetail = async () => {
  const { Data } = await borrowApplyDetail({ Id: BranchCompanyFlowId.value });
  personBorrowLoanamount.value.Loanamount = Data?.PageData?.BorrowAmount;
  actionButtons.value = Data?.ActionButtons || [];
  if (Data?.PageFiles.length > 0) {
    formItemPersonBorrow.value.PageFiles = Data?.PageFiles;
  }
  WorkFlowId.value = Data?.WorkFlowId;
};
// 撤回申请
const submiRecallApply = async () => {
  if (!recallResume.value) {
    message.error("请输入撤回理由");
    return;
  }
  if (currentStep.value == 0) {
    handleRecallBudgetApply();
  } else {
    handleRecalBorrowlApply();
  }
};
// 撤回财务预算申请
const handleRecallBudgetApply = async () => {
  const { Success, Message } = await recallBudgetApply({
    Reason: recallResume.value,
    BusinessFlowId: BranchCompanyFlowId.value,
  });
  if (Success) {
    message.success("撤回成功");
    handleCancelResume();
    recallVisible.value = false;

    // 获取详情
    getBudgetDetail();
    $emit("update-flow");
  } else {
    message.error(Message || "撤回失败，请稍后重试");
    handleCancelResume();
  }
};
// 撤回个人借款申请
const handleRecalBorrowlApply = async () => {
  const { Success, Data, Message } = await borrowRecallApply({
    Reason: recallResume.value,
    BusinessFlowId: BranchCompanyFlowId.value,
  });
  if (Success) {
    message.success("撤回成功");
    recallVisible.value = false;
    // 获取个人借款申请详情
    getBorrowApplyDetail();
    $emit("update-flow");
  } else {
    message.error(Message || "撤回失败，请稍后重试");
    handleCancelResume();
  }
  actionButtons.value = Data?.ActionButtons || [];
};
//重新提交财务预算
const submitEditBudgetApply = async () => {
  const { Success, Message } = await editBudgetApply({
    PageFiles: formItemFinancial.value.PageFiles,
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  if (Success) {
    message.success("已提交审核");
    $emit("update-flow");
    reEdit.value = false;
  } else {
    message.success(Message || "提交失败，请稍后重试");
  }
};
//重新提交个人借款
const submitEditBorrowApply = async () => {
  const { Success, Message } = await borrowEditApply({
    PageData: {
      BorrowAmount: personBorrowLoanamount.value.Loanamount,
    },
    PageFiles: formItemPersonBorrow.value.PageFiles,
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  if (Success) {
    message.success("已提交审核");
    $emit("update-flow");
    reEdit.value = false;
  } else {
    message.success(Message || "提交失败，请稍后重试");
  }
};
const handleCancelResume = () => {
  recallResume.value = "";
};
const handleTabChange = (index: number) => {
  reEdit.value = false;
  if (index == 0) {
    BranchCompanyFlowId.value = filterCompanyCode("201");
    getBudgetDetail();
  } else if (index == 1) {
    BranchCompanyFlowId.value = filterCompanyCode("202");
    getBorrowApplyDetail();
  }
};
const filterCompanyCode = (code: string) => {
  WorkFlowId.value = 0;
  const { id, type } = route.query;
  const item_data = props.flowData.find((item) => item.Code == code);
  if (!item_data) {
    preData.value = {
      Title: "开业申请",
      PreConditionCode: "0",
      BranchCompanyFlowId: 0,
    };
  } else {
    currentData.value = props.flowData.find(
      (item: NodeItem) => item.Code == code
    );
    preData.value = props.flowData.find(
      (_item: NodeItem) => _item.Code == item_data?.PreConditionCode
    );
    if (!item_data.IsAnchorPoint) {
      preData.value = {
        Title: "财务预算申请",
        PreConditionCode: "0",
        BranchCompanyFlowId: 0,
      };
      currentStep.value == 0;
    }
    if (currentData.value?.IsOperation) {
      //前置节点已完成
      preData.value = null;
    }
  }
  if (!type) {
    return item_data?.BranchCompanyFlowId || 0;
  } else if (code == type) {
    return id || item_data?.BranchCompanyFlowId || 0;
  } else if (code != type) {
    return item_data?.BranchCompanyFlowId || 0;
  }
};
const handleRejectback = () => {
  rejectedVisible.value = !rejectedVisible.value;
  $emit("update-flow");
  getList();
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  $emit("update-flow");
  getList();
};

const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadTitle, { title: "提交财务预算及借款流程" }),
        _createVNode(HelpText, {
          class: "border-bottom",
          list: list,
          width: 180,
          height: 70
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "提交预算单及借款注意事项" }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: require('../../assets/imgs/Book/attention.png')
            }, null, 8, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileList, (item, index) => {
              return _createVNode(HelpFile, {
                key: index,
                title: item.title,
                "file-path": item.link,
                "file-type": item.type
              }, null, 8, ["title", "file-path", "file-type"])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(USERLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(HeadTitle, { title: "审批事项" }),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_steps, {
                  class: "open-steps",
                  current: currentStep.value,
                  "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((currentStep).value = $event)),
                  onChange: handleTabChange,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_step, {
                      title: "财务预算申请",
                      status: currentStep.value == 0 ? 'process' : 'wait'
                    }, null, 8, ["status"]),
                    _createVNode(_component_a_step, {
                      title: "个人借款申请",
                      status: currentStep.value == 1 ? 'process' : 'wait'
                    }, null, 8, ["status"])
                  ]),
                  _: 1
                }, 8, ["current"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (currentStep.value == 0)
                  ? (_openBlock(), _createBlock(_component_a_form, {
                      key: 0,
                      layout: "vertical",
                      model: _unref(formItemFinancial),
                      validateTrigger: "blur",
                      class: _normalizeClass(["form-upload", 
                currentData.value && currentData.value.State > 1 && !reEdit.value
                  ? 'border-bottom'
                  : ''
              ]),
                      ref_key: "formRef",
                      ref: formRef
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          name: ['PageFiles', 0, 'FileUrl'],
                          label: "经营预算",
                          required: "",
                          class: "form-upload-item",
                          rules: [{ required: true, message: '请上传财务预算文件' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              value: 
                    _unref(formItemFinancial).PageFiles &&
                    _unref(formItemFinancial).PageFiles.length > 0
                      ? _unref(formItemFinancial).PageFiles[0]?.FileUrl
                      : ''
                  ,
                              "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                              disable: !!preData.value,
                              "file-type": '211',
                              onUpload: _cache[1] || (_cache[1] = (file) => handleUpload(file, 0)),
                              "download-link": {
                    filename: '财务预算.xlsx',
                    fileKey: '2011',
                  }
                            }, null, 8, ["value", "disable-close", "disable", "download-link"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          name: ['PageFiles', 1, 'FileUrl'],
                          label: "开业预算",
                          required: "",
                          class: "form-upload-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              value: 
                    _unref(formItemFinancial).PageFiles &&
                    _unref(formItemFinancial).PageFiles.length > 0
                      ? _unref(formItemFinancial).PageFiles[1]?.FileUrl
                      : ''
                  ,
                              "file-type": '212',
                              "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                              disable: !!preData.value,
                              onUpload: _cache[2] || (_cache[2] = (file) => handleUpload(file, 1)),
                              "download-link": {
                    filename: '开业预算.xls',
                    fileKey: '2012',
                  }
                            }, null, 8, ["value", "disable-close", "disable", "download-link"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "class"]))
                  : _createCommentVNode("", true),
                (currentStep.value == 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_a_form, {
                        layout: "vertical",
                        model: _unref(formItemPersonBorrow),
                        validateTrigger: "blur",
                        class: "form-upload",
                        ref_key: "formRefPersonBorrow",
                        ref: formRefPersonBorrow
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            name: ['PageFiles', 0, 'FileUrl'],
                            label: "个人借款协议",
                            required: "",
                            class: "form-upload-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                    _unref(formItemPersonBorrow).PageFiles &&
                    _unref(formItemPersonBorrow).PageFiles.length > 0
                      ? _unref(formItemPersonBorrow).PageFiles[0]?.FileUrl
                      : ''
                  ,
                                "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                disable: !!preData.value,
                                "file-type": '221',
                                "download-link": {
                    filename: '个人借款协议.docx',
                    fileKey: '2021',
                  },
                                onUpload: _cache[3] || (_cache[3] = (file) => handleUpload(file, 0))
                              }, null, 8, ["value", "disable-close", "disable", "download-link"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            name: ['PageFiles', 1, 'FileUrl'],
                            label: "合同会签",
                            class: "form-upload-item",
                            required: "",
                            style: {"width":"236px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                    _unref(formItemPersonBorrow).PageFiles &&
                    _unref(formItemPersonBorrow).PageFiles.length > 0
                      ? _unref(formItemPersonBorrow).PageFiles[1]?.FileUrl
                      : ''
                  ,
                                "file-type": '222',
                                disable: !!preData.value,
                                "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                "download-link": {
                    filename: '合同会签.docx',
                    fileKey: '2022',
                  },
                                onUpload: _cache[4] || (_cache[4] = (file) => handleUpload(file, 1))
                              }, null, 8, ["value", "disable", "disable-close", "download-link"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      (WorkFlowId.value == 0 || reEdit.value)
                        ? (_openBlock(), _createBlock(_component_a_form, {
                            key: 0,
                            style: {"height":"56px"},
                            model: _unref(personBorrowLoanamount),
                            ref_key: "formItemLoanamount",
                            ref: formItemLoanamount
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "借款金额",
                                required: "",
                                class: "form-money",
                                name: "Loanamount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    placeholder: "请输入金额",
                                    value: _unref(personBorrowLoanamount).Loanamount,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(personBorrowLoanamount).Loanamount) = $event)),
                                    rules: [
                    {
                      max: 50,
                    },
                  ],
                                    onInput: fpNumInput
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _hoisted_13
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("span", _hoisted_16, [
                              _createTextVNode(_toDisplayString(_unref(personBorrowLoanamount).Loanamount) + "元", 1),
                              _hoisted_17
                            ]),
                            _hoisted_18
                          ]))
                    ], 64))
                  : _createCommentVNode("", true),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, { id: WorkFlowId.value }, null, 8, ["id"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (actionButtons.value?.length > 0)
        ? (_openBlock(), _createBlock(ButtonGroup, {
            key: 1,
            "type-list": actionButtons.value,
            onClick: handleClick,
            "show-tips": 
        preData.value && preData.value.Title
          ? `提示：完成${preData.value.Title}审批后方可申请该模块`
          : ''
      
          }, null, 8, ["type-list", "show-tips"]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        class: "modal-dialog",
        bodyStyle: {
        width: '460px',
        height: '216px',
      },
        visible: recallVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((recallVisible).value = $event)),
        title: "撤回理由",
        onOk: submiRecallApply,
        onCancel: handleCancelResume
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            style: {"padding-left":"0"},
            value: recallResume.value,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((recallResume).value = $event)),
            bordered: false,
            placeholder: "请填写撤回理由",
            maxlength: 100,
            "auto-size": { minRows: 5, maxRows: 5 }
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"])
  ], 64))
}
}

})